import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardContent,
  Divider,
  Grid,
  Typography
} from '@material-ui/core';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import PeopleIcon from '@material-ui/icons/PeopleOutlined';
import { red, green } from '@material-ui/core/colors';


//My Components
import AddCash from '../../testComponents/addCollection';

const Budget = (props) => (
  <Card
    // sx={{ height: '100%' }}
    {...props}
  >
    <CardContent>
      <Grid
        container
        spacing={3}
        sx={{ justifyContent: 'space-between' }}
      >
        <Grid item>
          <Typography
            color="textSecondary"
            gutterBottom
            variant="body2"
          >
            Total Receivables
          </Typography>
          <Typography
            color="primary"
            variant="h6"
            className="mb-3"
          >
            ₱24,000
          </Typography>
   
        </Grid>
        <Grid item>
          <Avatar
            sx={{
              backgroundColor: red[600],
              height: 56,
              width: 56
            }}
          >
            <LibraryBooksIcon />
          </Avatar>
        </Grid>
        
      </Grid>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          pt: 1
        }}
      >
        <ArrowDownwardIcon sx={{ color: red[900] }} />
        <Typography
          variant="body2"
          sx={{
            color: red[900],
            mr: 1
          }}
        >
          10%
        </Typography>
        <Typography
          color="textSecondary"
          variant="caption"
        >
         Allowance for doubtful
        </Typography>
      </Box>
      <Typography
            color="primary"
            variant="h6"
          >
            ₱24,000
          </Typography>
    </CardContent>
    <Divider/>
    <CardActions style={{
       display: 'flex',
       alignItems: 'center',
       justifyContent: 'center',
    }}>
     <AddCash/>
    </CardActions>
  </Card>
);

export default Budget;
